import StatusChip from "@common/components/statusChip/StatusChip.tsx";
import { SystemStatus } from "../systemEdit/SystemEdit.types.ts";

export interface SystemStatusChipProps {
    status: SystemStatus | "Expired";
    value: string;
}

function SystemStatusChip(props: SystemStatusChipProps) {
    function getChipColor(status: SystemStatus | "Expired") {
        switch (status) {
            case SystemStatus.Active:
                return "green";
            case SystemStatus.UnderImplementation:
                return "lightgreen";
            case SystemStatus.PhasedOut:
                return "purple";
            case SystemStatus.UnderRetirement:
                return "orange";
            case "Expired":
                return "red";
        }
    }

    return <StatusChip value={props.value} status={getChipColor(props.status)} />;
}

export default SystemStatusChip;
